import React from 'react';

import { NextPageWithLayout } from 'next';

import { Container } from '../../components/Container/Container';
import { Heading } from '../../components/Heading/Heading';
import { Text } from '../../components/Text/Text';
import { MetaTags } from '../../components/MetaTags/MetaTags';
import { UNSUPPORTED_DEEPLINKS_METADATA } from './constants/constants';

export interface IEmailErrorProps {
  errorSource: string;
}

export const EmailError: NextPageWithLayout<IEmailErrorProps> = ({ errorSource }) => {
  const metaTitle =
    UNSUPPORTED_DEEPLINKS_METADATA.find(metadata => metadata.sourcePath === errorSource)
      ?.metaTitle ?? 'Fishbrain is better in the app';

  return (
    <Container className="flex flex-col items-center">
      <MetaTags link="/email-error" title={metaTitle} />
      <Heading as="h1">Well this is a little embarrassing</Heading>
      <Text className="mb-16">
        Currently you can only view this on your mobile phone. Follow the steps below to open in
        Fishbrain.
      </Text>
      <div className="mb-32 flex flex-row flex-wrap gap-4 text-center md:gap-16">
        <div className="flex w-full flex-col items-center md:w-48">
          <div className="mb-4 flex size-48 items-center justify-center rounded-full bg-[#ea583f] text-6xl font-bold text-white">
            1
          </div>
          <Heading variant="sm" className="mb-4">
            Step one
          </Heading>
          <Text>Pick up your mobile phone.</Text>
        </div>
        <div className="flex w-full flex-col items-center md:w-48">
          <div className="mb-4 flex size-48 items-center justify-center rounded-full bg-[#f7bb43] text-6xl font-bold text-white">
            2
          </div>
          <Heading variant="sm" className="mb-4">
            Step two
          </Heading>
          <Text>Click the email link on your phone.</Text>
        </div>
        <div className="flex w-full flex-col items-center md:w-48">
          <div className="mb-4 flex size-48 items-center justify-center rounded-full bg-[#8cd149] text-6xl font-bold text-white">
            3
          </div>
          <Heading variant="sm" className="mb-4">
            Step three
          </Heading>
          <Text>You will see the screen you were looking for in the Fishbrain app.</Text>
        </div>
      </div>
    </Container>
  );
};
